var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MagicIcon_svg__clip0_18040_344934)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "MagicIcon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5.5H.5v24h24V.5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.917 5.976l2.107 2.107L7.169 19.937l-2.106-2.106L16.916 5.976z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.063 17.83l-3.424 3.424a1.49 1.49 0 102.107 2.106l3.423-3.423-2.106-2.107z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.232 22a.703.703 0 000-.995l-4.693-4.693a.703.703 0 10-.995.994L8.237 22c.275.275.72.275.995 0z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.783 3.144l3.081-1.053-1.038 3.086 1.954 2.605-3.256-.033-1.873 2.663-.974-3.107-3.112-.959 2.653-1.886-.05-3.256 2.615 1.94z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.783 12.208a.703.703 0 00.46-.882L17.27 8.22a.703.703 0 00-.464-.461l-3.112-.959a.703.703 0 00-.414 1.344l2.759.85.864 2.754c.116.37.51.577.881.46z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.385 16.268a3.206 3.206 0 013.206 3.206 3.206 3.206 0 013.206-3.206v-.008a3.206 3.206 0 01-3.206-3.206 3.206 3.206 0 01-3.206 3.206v.008zM1.203 4.417A3.206 3.206 0 014.41 7.623a3.206 3.206 0 013.206-3.206V4.41a3.206 3.206 0 01-3.206-3.206A3.206 3.206 0 011.203 4.41v.008z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#MagicIcon_svg__a)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.917 5.976l2.107 2.107L7.169 19.937l-2.106-2.106L16.916 5.976z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17 20.64a.703.703 0 00.497-.205L19.52 8.58a.703.703 0 000-.994l-2.107-2.107a.703.703 0 00-.994 0L4.565 17.333a.703.703 0 000 .995l2.107 2.107c.132.132.31.206.497.206zm0-1.697l-1.113-1.112 10.86-10.86 1.113 1.112-10.86 10.86z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "MagicIcon_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h24v24H.5V.5z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#MagicIcon_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.063 17.83l-3.424 3.424a1.49 1.49 0 102.107 2.106l3.423-3.423-2.106-2.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 22.863a.787.787 0 11-1.113-1.112l2.926-2.926 1.112 1.112-2.926 2.926zm-2.108.995a2.193 2.193 0 003.102 0l3.423-3.423a.703.703 0 000-.995L5.56 17.333a.703.703 0 00-.995 0l-3.423 3.423a2.193 2.193 0 000 3.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.232 22a.703.703 0 000-.995l-4.693-4.693a.703.703 0 10-.995.994L8.237 22c.275.275.72.275.995 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.783 3.144l3.081-1.053-1.038 3.086 1.954 2.605-3.256-.033-1.873 2.663-.974-3.107-3.112-.959 2.653-1.886-.05-3.256 2.615 1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.543 11.107a.703.703 0 00.683-.29l1.66-2.361 2.887.03a.703.703 0 00.57-1.126L22.61 5.051l.92-2.736a.703.703 0 00-.894-.89l-2.732.934L17.587.64a.703.703 0 00-1.122.575l.045 2.887-2.353 1.672a.703.703 0 00.2 1.245l2.76.85.863 2.755c.08.255.298.443.563.484zm.352-2.265l-.548-1.747a.703.703 0 00-.463-.462l-1.751-.54 1.493-1.06a.703.703 0 00.295-.584l-.028-1.832 1.471 1.092a.703.703 0 00.647.1l1.733-.592-.584 1.736a.703.703 0 00.104.646l1.099 1.465-1.831-.018a.703.703 0 00-.583.298l-1.054 1.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.783 12.208a.703.703 0 00.46-.882L17.27 8.22a.703.703 0 00-.464-.461l-3.112-.959a.703.703 0 00-.414 1.344l2.759.85.864 2.754c.116.37.51.577.881.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.385 16.268a3.206 3.206 0 013.206 3.206 3.206 3.206 0 013.206-3.206v-.008a3.206 3.206 0 01-3.206-3.206 3.206 3.206 0 01-3.206 3.206v.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.591 20.177a.703.703 0 00.703-.703 2.503 2.503 0 012.503-2.503.703.703 0 00.703-.703v-.008a.703.703 0 00-.703-.703 2.503 2.503 0 01-2.503-2.503.703.703 0 00-1.406 0 2.503 2.503 0 01-2.503 2.503.703.703 0 00-.703.703v.008c0 .388.315.703.703.703a2.503 2.503 0 012.503 2.503c0 .388.315.703.703.703zm0-2.94a3.932 3.932 0 00-.974-.973c.379-.264.71-.594.974-.973.265.379.595.709.974.973a3.93 3.93 0 00-.974.972z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.203 4.417A3.206 3.206 0 014.41 7.623a3.206 3.206 0 013.206-3.206V4.41a3.206 3.206 0 01-3.206-3.206A3.206 3.206 0 011.203 4.41v.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.409 8.326a.703.703 0 00.703-.703A2.503 2.503 0 017.615 5.12a.703.703 0 00.703-.703V4.41a.703.703 0 00-.703-.703 2.503 2.503 0 01-2.503-2.503.703.703 0 00-1.406 0 2.503 2.503 0 01-2.503 2.503.703.703 0 00-.703.703v.008c0 .389.315.703.703.703a2.503 2.503 0 012.503 2.503c0 .388.315.703.703.703zm0-2.94a3.93 3.93 0 00-.974-.973c.379-.264.71-.594.974-.972.265.378.595.708.974.972-.379.264-.71.594-.974.973z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MagicIcon_svg__clip0_18040_344934"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h24v24H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/MagicIcon.54612522.svg";
export { SvgMagicIcon as ReactComponent };